import axios from '../../utils/axios';

const getOrdersPerPage = async (
  page,
  limit,
  orderSearchValue,
  clientId,
  startDate,
  endDate,
  storeIds = [],
  sellerIds = [],
) => {
  const base = `/api/orders?page=${page}&limit=${limit}`
    + `&orderSearchValue=${orderSearchValue}`
    + `&clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`
    + `&storeIds=${storeIds.join(',')}&sellerIds=${sellerIds.join(',')}`;
  const response = await axios.get(base);
  return response.data;
};

const getOrderById = async (id) => {
  const response = await axios.get(`/api/order/${id}`);
  return response.data;
};

const exportCSVOrder = async (csvData) => {
  const response = await axios.post('/api/order/downloadCsv', csvData);
  return response.data;
};

const getOrdersByStatus = async (clientId, status, startDate, endDate) => {
  const response = await axios.get(`/api/orders/status?clientId=${clientId}&status=${status}&startDate=${startDate}&endDate=${endDate}`);
  return response.data;
};
const getOrdersXlsx = async (clientId, startDate, endDate, storeId) => {
  const response = await axios.get(
    `/api/orders/xlsx?clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`
    + `&storeId=${storeId || ''}`,
  );
  return response.data;
};

export {
  getOrdersPerPage,
  getOrderById,
  exportCSVOrder,
  getOrdersByStatus,
  getOrdersXlsx,
};
